import React, { useState } from "react";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const MessageA20 = (props) => {
  const [isFullPage, setIsFullPage] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);

  const data = props.item && props.item.text_data && props.item.text_data.link;

  const [activeStep, setActiveStep] = React.useState(0);

  const maxSteps = data.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const toggleFullScreen = () => {
    setIsFullPage(!isFullPage);
  };

  const renderImages = () => {
    if (data.length === 1) {
      return (
        <>
          <img
            className="img-contain"
            src={data[0]}
            alt={data[0]}
            onClick={toggleFullScreen}
          />
          {isFullPage && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 99999,
              }}
            >
              <img
                src={data}
                alt={data}
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  cursor: "pointer",
                }}
                onClick={toggleFullScreen}
              />
            </div>
          )}
        </>
      );
    } else {
      return (
        <>
          <img
            className="img-contain"
            src={data[carouselIndex]}
            alt={data[carouselIndex]}
            onClick={toggleFullScreen}
          />
          {isFullPage && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                // height: "100%",
                background: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 99999,
              }}
            >
              <Paper
                square
                elevation={0}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: 50,
                  pl: 2,
                  bgcolor: "background.default",
                }}
                style={{ position: "fixed" }}
              ></Paper>
              <SwipeableViews
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {data.map((step, index) => (
                  <div key={step.label}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <Box
                        component="img"
                        onClick={toggleFullScreen}
                        src={step}
                        alt={step}
                        sx={{ width: '100%' , height : '100vh'}}
                      />
                    ) : null}
                  </div>
                ))}
              </SwipeableViews>
              <MobileStepper
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    disabled={activeStep === 0}
                    style={{ position: "fixed", left: "10%" }}
                  >
                    <KeyboardArrowLeft />
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    style={{ position: "fixed", right: "10%" }}
                    disabled={activeStep === maxSteps - 1}
                  >
                    <KeyboardArrowRight />
                  </Button>
                }
              />
            </div>
          )}
        </>
      );
    }
  };

  return (
    <div className="img-wrap">
      <span className="img-wrap-content" onClick={toggleFullScreen}>
        Click here for the image
      </span>
      {renderImages()}
    </div>
  );
};

export default MessageA20;
